export const parseCurrencyValue = (value: unknown): number => {
  if (value === null || value === undefined || value === "") {
    return 0;
  }

  if (typeof value === "number") {
    return value;
  }

  const stringValue = String(value).trim();

  if (!stringValue) {
    return 0;
  }

  const normalizedValue = stringValue.includes(",")
    ? stringValue.replace(/\./g, "").replace(",", ".")
    : stringValue;

  const parsed = Number(normalizedValue);

  if (Number.isNaN(parsed)) {
    return 0;
  }

  return Number(Number(parsed.toFixed(2)));
};